import {
  ActionType,
  LoadingType,
  SetErrorPayload,
  SetInstallmentsPayload,
  SetNotesPayload,
  SetOrderPayload,
  SetOrgIdPayload,
  SetPreviewLineItemsPayload,
  SetTransactionsPayload,
} from './types';

export interface OrderDetailsAction {
  type: ActionType;
  loading?: { loadingType: LoadingType; isLoading: boolean; error?: string };
  payload?:
    | SetOrderPayload
    | SetOrgIdPayload
    | SetNotesPayload
    | SetErrorPayload
    | SetTransactionsPayload
    | SetInstallmentsPayload
    | SetPreviewLineItemsPayload;
}

export const orderDetailReducer = (
  state: any,
  action: OrderDetailsAction
): any => {
  switch (action.type) {
    case ActionType.SetError: {
      const { error } = action.payload as SetErrorPayload;
      return { ...state, error };
    }
    case ActionType.SetLoading: {
      const { loadingType, isLoading, error } = action.loading;
      return {
        ...state,
        loading: { ...state.loading, [loadingType]: isLoading, error },
      };
    }
    case ActionType.SetOrgId: {
      const { orgId } = action.payload as SetOrgIdPayload;
      return { ...state, orgId };
    }
    case ActionType.SetOrder: {
      const { order } = action.payload as SetOrderPayload;
      return { ...state, order };
    }
    case ActionType.SetNotes: {
      const { notes } = action.payload as SetNotesPayload;
      return { ...state, notes };
    }
    case ActionType.SetTransactions: {
      const { transactions } = action.payload as SetTransactionsPayload;
      return { ...state, transactions };
    }
    case ActionType.SetInstallments: {
      const { installments } = action.payload as SetInstallmentsPayload;
      return { ...state, installments };
    }
    case ActionType.SetPreviewLineItems: {
      const { previewLineItems } = action.payload as SetPreviewLineItemsPayload;
      return { ...state, previewLineItems };
    }
    default:
      return state;
  }
};
